export * from './dtos/proto-tenant-settings.dto';
